import { render, staticRenderFns } from "./CoPlanDetail.vue?vue&type=template&id=b8d3429a&scoped=true&"
import script from "./CoPlanDetail.vue?vue&type=script&lang=ts&"
export * from "./CoPlanDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d3429a",
  null
  
)

export default component.exports